import { predict as publicPredict } from './atlas-v2-prediction-autocomplete.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const predict: MaybeContext<
  BuildRESTFunction<typeof publicPredict> & typeof publicPredict
> = /*#__PURE__*/ createRESTModule(publicPredict);

export { FilterType } from './atlas-v2-prediction-autocomplete.universal.js';
export {
  Prediction,
  MatchedSubstrings,
  TextStructure,
  ListPredictionsRequest,
  AddressLocation,
  FilterBy,
  ListPredictionsResponse,
  PredictRequest,
  PredictResponse,
  PredictOptions,
} from './atlas-v2-prediction-autocomplete.universal.js';
export { FilterTypeWithLiterals } from './atlas-v2-prediction-autocomplete.universal.js';
